import React, { useState } from 'react';
import { CButton } from '@coreui/react-pro';
import { WarningCircleIcon, ArrowClockwiseIcon, CopyIcon, CheckIcon } from '@phosphor-icons/react';
import './ErrorState.scss';

/*
 * ErrorState — Module UI Guide §15. What failed in the user's terms plus a
 * retry; never a stack trace. A standing error stays on screen (not a toast
 * that disappears). Correlation id in mono, copyable.
 *
 * Usage:
 *   <ErrorState message="The server did not respond. Your data is safe."
 *               onRetry={reload} correlationId={reqId} />
 */
const ErrorState = ({
	title = 'Could not load this',
	message = 'Something went wrong. Please try again.',
	onRetry,
	retryLabel = 'Retry',
	correlationId,
	className = '',
}) => {
	const [copied, setCopied] = useState(false);

	const copyId = () => {
		if (!correlationId) return;
		try {
			navigator.clipboard?.writeText(String(correlationId));
			setCopied(true);
			setTimeout(() => setCopied(false), 1500);
		} catch (e) {
			/* clipboard unavailable — id is still visible to read off */
		}
	};

	return (
		<div className={`ivs-error ${className}`.trim()} role="alert">
			<div className="ivs-error__icon" aria-hidden="true">
				<WarningCircleIcon size={28} weight="bold" />
			</div>
			{title && <div className="ivs-error__title">{title}</div>}
			{message && <p className="ivs-error__msg">{message}</p>}
			{onRetry && (
				<CButton className="outline-btn ivs-error__retry" onClick={onRetry}>
					<ArrowClockwiseIcon size={16} weight="bold" /> {retryLabel}
				</CButton>
			)}
			{correlationId && (
				<button type="button" className="ivs-error__cid" onClick={copyId} title="Copy reference id">
					<span>{correlationId}</span>
					{copied ? <CheckIcon size={13} weight="bold" /> : <CopyIcon size={13} weight="bold" />}
				</button>
			)}
		</div>
	);
};

export default ErrorState;
